import React, { useEffect, useState } from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import { customersService, partnersService } from '../services/api';
import { toast } from 'react-toastify';
import { Icon } from '@iconify/react/dist/iconify.js';

const PotentialCustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  });
  const [filters, setFilters] = useState({
    partner_id: '',
    search: '',
    sortBy: 'created_at',
    sortOrder: 'DESC'
  });

  useEffect(() => {
    loadPartners();
    loadCustomers();
  }, [pagination.page, pagination.limit, filters]);

  const loadPartners = async () => {
    try {
      const response = await partnersService.getAllPartners({ 
        status: 'approved',
        limit: 1000 
      });
      if (response.success) {
        setPartners(response.data || []);
      }
    } catch (error) {
      console.error('Error loading partners:', error);
    }
  };

  const loadCustomers = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.page,
        limit: pagination.limit,
        ...filters
      };

      // Boş filtreleri kaldır
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null) {
          delete params[key];
        }
      });

      const response = await customersService.getAllPotentialCustomers(params);

      if (response.success) {
        setCustomers(response.data || []);
        setPagination(prev => ({
          ...prev,
          total: response.pagination?.total || 0,
          totalPages: response.pagination?.totalPages || 0
        }));
      } else {
        toast.error(response.error || 'Potansiyel müşteriler yüklenemedi');
      }
    } catch (error) {
      console.error('Error loading customers:', error);
      toast.error('Potansiyel müşteriler yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
    setPagination(prev => ({ ...prev, page: 1 }));
  };

  const handlePageSizeChange = (e) => {
    setPagination(prev => ({ ...prev, limit: parseInt(e.target.value), page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Potansiyel Müşteriler" />
      <div className="card">
        <div className="card-header">
          <h5 className="card-title mb-0">Potansiyel Müşteriler</h5>
        </div>
        <div className="card-body">
          {/* Filtreler */}
          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <label className="form-label">Partner</label>
              <select
                className="form-select"
                value={filters.partner_id}
                onChange={(e) => handleFilterChange('partner_id', e.target.value)}
              >
                <option value="">Tümü</option>
                {partners.map(partner => (
                  <option key={partner.id} value={partner.id}>
                    {partner.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-4">
              <label className="form-label">Arama</label>
              <input
                type="text"
                className="form-control"
                placeholder="İsim, telefon, e-posta ara..."
                value={filters.search}
                onChange={(e) => handleFilterChange('search', e.target.value)}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Sıralama</label>
              <select
                className="form-select"
                value={`${filters.sortBy}_${filters.sortOrder}`}
                onChange={(e) => {
                  const [sortBy, sortOrder] = e.target.value.split('_');
                  setFilters(prev => ({ ...prev, sortBy, sortOrder }));
                }}
              >
                <option value="created_at_DESC">Oluşturulma (Yeni → Eski)</option>
                <option value="created_at_ASC">Oluşturulma (Eski → Yeni)</option>
                <option value="name_ASC">İsim (A → Z)</option>
                <option value="name_DESC">İsim (Z → A)</option>
              </select>
            </div>
          </div>

          {/* Tablo */}
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
            </div>
          ) : customers.length === 0 ? (
            <div className="alert alert-info text-center">
              Potansiyel müşteri bulunamadı.
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Müşteri</th>
                      <th>Telefon</th>
                      <th>E-posta</th>
                      <th>Partner</th>
                      <th>Ekleyen</th>
                      <th>Adres</th>
                      <th>Oluşturulma</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.map(customer => (
                      <tr key={customer.id}>
                        <td>
                          <strong>{customer.name}</strong>
                        </td>
                        <td>{customer.phone || '-'}</td>
                        <td>{customer.email || '-'}</td>
                        <td>
                          <div>
                            <strong>{customer.partner_name}</strong>
                            {customer.partner_phone && (
                              <div className="text-muted small">{customer.partner_phone}</div>
                            )}
                          </div>
                        </td>
                        <td>
                          <span className="badge bg-secondary">{customer.added_by_name}</span>
                        </td>
                        <td>
                          {customer.address ? (
                            <div>
                              {customer.address}
                              {(customer.city || customer.district) && (
                                <div className="text-muted small">
                                  {customer.district && customer.city 
                                    ? `${customer.district}, ${customer.city}`
                                    : customer.city || customer.district}
                                </div>
                              )}
                            </div>
                          ) : '-'}
                        </td>
                        <td>{formatDate(customer.created_at)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-4">
                <div>
                  <select
                    className="form-select form-select-sm"
                    style={{ width: 'auto', display: 'inline-block' }}
                    value={pagination.limit}
                    onChange={handlePageSizeChange}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ms-2 text-muted">
                    Toplam {pagination.total} kayıt
                  </span>
                </div>
                <nav>
                  <ul className="pagination mb-0">
                    <li className={`page-item ${pagination.page === 1 ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(pagination.page - 1)}
                        disabled={pagination.page === 1}
                      >
                        Önceki
                      </button>
                    </li>
                    {[...Array(pagination.totalPages)].map((_, i) => {
                      const page = i + 1;
                      if (
                        page === 1 ||
                        page === pagination.totalPages ||
                        (page >= pagination.page - 2 && page <= pagination.page + 2)
                      ) {
                        return (
                          <li key={page} className={`page-item ${pagination.page === page ? 'active' : ''}`}>
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(page)}
                            >
                              {page}
                            </button>
                          </li>
                        );
                      } else if (
                        page === pagination.page - 3 ||
                        page === pagination.page + 3
                      ) {
                        return (
                          <li key={page} className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        );
                      }
                      return null;
                    })}
                    <li className={`page-item ${pagination.page === pagination.totalPages ? 'disabled' : ''}`}>
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(pagination.page + 1)}
                        disabled={pagination.page === pagination.totalPages}
                      >
                        Sonraki
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </>
          )}
        </div>
      </div>
    </MasterLayout>
  );
};

export default PotentialCustomersPage;

